"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDashboard = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const helpers_1 = require("../../../utils/helpers");
const alert_box_1 = require("../../../widgets/alert_box");
const chart_view_1 = require("../../../widgets/chart_view");
const form_for_1 = require("../../../widgets/form_for");
const contracts_sold_1 = require("./charts/contracts_sold");
const occupancy_1 = require("./charts/occupancy");
const per_period_average_price_1 = require("./charts/per_period_average_price");
const perPeriodAveragePrice = (0, chart_view_1.ChartView)(per_period_average_price_1.PerPeriodAveragePrice);
const occupancyRate = (0, chart_view_1.ChartView)(occupancy_1.Occupancy);
const contractsSold = (0, chart_view_1.ChartView)(contracts_sold_1.ContractsSold);
let years = {};
for (let x = 2019; x <= (new Date()).getFullYear(); x++) {
    years["" + x] = ["" + x];
}
const MONTH_SELECTION = Object.assign({ "0": "Toute l'année" }, helpers_1.MONTHS);
const config = {
    currentYear: `${(new Date()).getFullYear()}`,
    currentMonth: `${(new Date()).getMonth() + 1}`
};
function updateKpis() {
    let charts = [perPeriodAveragePrice, occupancyRate, contractsSold];
    let period, periodStart;
    if (parseInt(config.currentMonth) == 0) {
        period = "month";
        periodStart = `${config.currentYear}-01-01`;
    }
    else {
        period = "day";
        let month = config.currentMonth;
        if (month.length == 1)
            month = "0" + month;
        periodStart = `${config.currentYear}-${month}-01`;
    }
    charts.forEach(chart => {
        chart.chart.refresh(period, periodStart).then(() => chart.update());
    });
}
function AdminDashboard() {
    return {
        activities: null,
        renderToolbox() {
            return (0, helpers_1.level)({
                left: [
                    (0, mithril_1.default)("div", { style: "min-width: 80px;" }, (0, form_for_1.selectField)("", "currentYear", years, config, { afterchange: updateKpis })),
                    (0, mithril_1.default)("div", { style: "min-width: 200px;" }, (0, form_for_1.selectField)("", "currentMonth", MONTH_SELECTION, config, { unsorted: true, afterchange: updateKpis }))
                ]
            });
        },
        renderBigChart() {
            return (0, mithril_1.default)(perPeriodAveragePrice);
        },
        renderChart1() {
            return (0, mithril_1.default)(occupancyRate);
        },
        renderChart2() {
            return (0, mithril_1.default)(contractsSold);
        },
        renderChart3() {
            if (this.activities) {
                let activeClientsPercent = (100 * this.activities.active_clients / this.activities.total_clients).toFixed(2);
                let activeRoomFillingPercent = (100 * this.activities.total_hours_booked_non_consumed / (160 * this.activities.hours_per_day)).toFixed(2);
                let totalHourSoldNotBookedYetPercent = (100 * this.activities.total_hours_sold_not_booked_yet / (160 * this.activities.hours_per_day)).toFixed(2);
                return [
                    (0, form_for_1.columns)((0, helpers_1.kpi)(this.activities.active_clients, "clients actifs", `ou ${activeClientsPercent}% des clients`), (0, helpers_1.kpi)(this.activities.active_contracts, "forfaits actifs")),
                    (0, form_for_1.columns)((0, helpers_1.kpi)(this.activities.total_hours_booked_non_consumed, "heures en réservation", `${activeRoomFillingPercent}% de remplissage à 6 mois`), (0, helpers_1.kpi)(this.activities.total_hours_sold_not_booked_yet.toFixed(2), "heures dans les forfaits actifs", `${totalHourSoldNotBookedYetPercent}% de remplissage à 6 mois`))
                ];
            }
            return (0, mithril_1.default)("div", { class: "content" }, (0, mithril_1.default)("h3", "Chargement..."));
        },
        renderChart4() {
            const alerts = () => {
                if (this.activities) {
                    if (this.activities.late_payments > 0) {
                        return (0, alert_box_1.alertBox)({
                            content: (0, mithril_1.default)("a", { href: "#/calendar/payments&" }, `Il y a ${this.activities.late_payments} paiement(s) en retard. Cliquez ici pour acceder aux paiements`),
                            level: "warning",
                            onclose: undefined
                        });
                    }
                    else {
                        return (0, mithril_1.default)("div", "Pas d'alertes");
                    }
                }
                else {
                    return (0, mithril_1.default)("h3", "Chargement...");
                }
            };
            return (0, mithril_1.default)(".card", (0, mithril_1.default)(".card-content.content", (0, mithril_1.default)("h3", "Alertes"), alerts()));
        },
        oncreate() {
            app_1.App.get("/stats/activities").then((data) => {
                this.activities = data;
            });
        },
        view() {
            return (0, mithril_1.default)("div", { style: "padding: 0 1em;" }, (0, form_for_1.columns)(this.renderChart3(), this.renderChart4()), this.renderToolbox(), (0, form_for_1.columns)(this.renderBigChart()), (0, form_for_1.columns)(this.renderChart1(), this.renderChart2()));
        }
    };
}
exports.AdminDashboard = AdminDashboard;
